// Admin.jsx
import { Routes, Route, Link } from "react-router-dom";
import "./admin/Admin.css";
import Announcement from "./admin/Announcement";
import Docs from "./admin/Docs";
import Movies from "./admin/Movies";
import Staff from "./admin/Staff";
import Users from "./admin/Users";
import AdminUsers from "./admin/AdminUsers";
import MovieRating from "./admin/MovieRating";
import Logout from "../components/Logout";
import { useAuth } from "../components/useAuth";

function AdminHome() {
  const { su_flag } = useAuth();
  console.log(su_flag);
  return (
    <>
      <h3 className="admin-page-title">管理メニュー</h3>
      <nav className="menu">
        <div className="nav_item">
          <Link to="/announcement">お知らせ管理</Link>
        </div>
        <div className="nav_item">
          <Link to="/docs">手術説明・同意管理</Link>
        </div>
        <div className="nav_item">
          <Link to="/movies">動画管理</Link>
        </div>
        <div className="nav_item">
          <Link to="/staff">スタッフ管理</Link>
        </div>
        <div className="nav_item">
          <Link to="/users">ユーザー管理</Link>
        </div>
        <div className="nav_item">
          <Link to="/movie_rating">動画アンケートダウンロード</Link>
        </div>
        {su_flag === 1 || su_flag === "1" ? (
          <div className="nav_item_end">
            <Link to="/adminusers">管理者管理</Link>
          </div>
        ) : (
          <div className="nav_item_end invalid">
            <Link>管理者管理(権限がありません)</Link>
          </div>
        )}
      </nav>
    </>
  );
}

function Admin() {
  const { su_flag } = useAuth();
  //console.log(su_flag);
  return (
    <div className="Admin">
      <header className="Admin-header">
        <div className="Admin-brand">
          <h1>
            <Link to="/">
              名市大消化器外科
              <br />
              opeNote管理
            </Link>
          </h1>
          <p className="Admin-brand-sub">管理コンソール</p>
        </div>
        <nav className="Admin-nav">
          <ul>
            <li>
              <Link to="/announcement" className="Admin-nav-link">
                お知らせ
              </Link>
            </li>
            <li>
              <Link to="/docs" className="Admin-nav-link">
                説明・同意
              </Link>
            </li>
            <li>
              <Link to="/movies" className="Admin-nav-link">
                動画
              </Link>
            </li>
            <li>
              <Link to="/staff" className="Admin-nav-link">
                スタッフ
              </Link>
            </li>
            <li>
              <Link to="/users" className="Admin-nav-link">
                ユーザー
              </Link>
            </li>
            <li>
              <Link to="/movie_rating" className="Admin-nav-link">
                動画アンケート
              </Link>
            </li>
            <li>
              {su_flag === 1 || su_flag === "1" ? (
                <Link to="/adminusers" className="Admin-nav-link">
                  管理者
                </Link>
              ) : (
                <Link className="Admin-nav-link invalid">
                  管理者
                </Link>
              )}
            </li>
            <li>
              <Link
                to="/logout"
                className="Admin-nav-link Admin-nav-link--danger"
              >
                Logout
              </Link>
            </li>
          </ul>
        </nav>
      </header>

      <main className="Admin-main">
        <div className="Admin-inner_content">
          <Routes>
            <Route path="/" element={<AdminHome />} />
            <Route path="announcement/*" element={<Announcement />} />
            <Route path="movies/*" element={<Movies />} />
            <Route path="docs/*" element={<Docs />} />
            <Route path="staff/*" element={<Staff />} />
            <Route path="users/*" element={<Users />} />
            <Route path="adminusers/*" element={<AdminUsers />} />
            <Route path="movie_rating/*" element={<MovieRating />} />
            <Route path="/logout" element={<Logout />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default Admin;
